import {
    type ViewStyle,
    type TextStyle,
    StyleSheet
} from "react-native";
import type {
    BreadcrumbPageDynamicStyleType
} from "./type";
import type {
    Mutable
} from "../../../../types";

const stylesheet = StyleSheet.create({
    container: {
        flexDirection: "row",
        alignItems: "center",
        flexShrink: 1
    },
    title: {
        flexShrink: 1
    }
});

export const useStyles = ({
    measures,
    spaces
}: BreadcrumbPageDynamicStyleType) => {
    return {
        title: {
            lineHeight: measures.lineHeight
        } as Mutable<TextStyle>,
        container: {
            gap: spaces.spacingXs
        } as Mutable<ViewStyle>
    };
};
export default stylesheet;
